<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Work Permit" />


        <div class="rec_count text-danger">
            <ul class="action">
                <li>All : {{workpermit.length}}</li>    
                <li>Active : {{active_workpermit.length}}</li>    
                <li>Expired : {{expired_workpermit.length}}</li>    
            </ul> 
             
        </div>
        <div class="container-fluid" v-if="isMobileView()">
            <div class="col-xxl-12">
                <div class="card">
                    <div class="card-header">
                       
                    </div>
                    <div class="card-body">
                        <ul class="nav nav-tabs border-tab border-0 mb-0 nav-danger" id="topline-tab" role="tablist">
                            <li class="nav-item"><a class="nav-link active nav-border pt-0 txt-danger nav-danger"
                                    id="all-gatepass-tab" data-bs-toggle="tab" href="#all-gatepass" role="tab"
                                    aria-controls="all-gatepass" aria-selected="true"><i
                                        class="icofont icofont-man-in-glasses"></i>All</a></li> 
                                        
                            <li class="nav-item"><a class="nav-link nav-border txt-danger nav-danger" id="ongoing-tab"
                                    data-bs-toggle="tab" href="#ongoing" role="tab" aria-controls="ongoing"
                                    aria-selected="false"><i class="icofont icofont-listine-dots"></i>Active</a>
                            </li>
                    
                            <li class="nav-item"><a class="nav-link nav-border txt-danger nav-danger" id="requested-tab"
                                    data-bs-toggle="tab" href="#requested" role="tab" aria-controls="requested"
                                    aria-selected="false"><i class="icofont icofont-listine-dots"></i>Expired</a>
                            </li>
                    
                            <li>
                                <button class="btn btn-primary" type="button" data-bs-toggle="modal"
                                data-original-title="test" data-bs-target="#workpermitAdd"><i class="icofont icofont-plus"></i>Create</button>
                            </li>
                        </ul>
                        
                        <div class="tab-content" id="topline-tabContent">
                            <!-- All Work Permits Card View -->
                            <div class="tab-pane fade show active" id="all-gatepass" role="tabpanel"
                                aria-labelledby="all-gatepass-tab">
                                <div class="card-body px-0 pb-0">
                                    <div class="user-header pb-2">
                                        <h6 class="fw-bold">All</h6>
                                        <button class="btn btn-primary text-white" @click="filterlist()" >filter</button>
                                    </div>
                    
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6" v-for="(item, index) in workpermit" :key="item.id">
                                            <div class="card mb-3">
                                                <div class="card-header bg-primary text-white">
                                                    <h5 class="text-white">{{ item.name }}</h5>
                                                    <small>{{ item.companyname }}</small>
                                                </div>
                                                <div class="card-body">
                                                    <p><strong>Employee Name:</strong> {{ item.employee_name }}</p>
                                                    <p><strong>Register Date:</strong> {{ item.iddate }}</p>
                                                    <p><strong>Address:</strong> {{ item.address }}</p>
                                                    <p><strong>Contact:</strong> {{ item.contact }}</p>
                                                    <p><strong>Designation:</strong> {{ item.designation }}</p>
                                                    <p><strong>Valid From:</strong> {{ item.fromdate }} <strong>To:</strong> {{ item.todate }}</p>
                                                    
                                                    <div class="d-flex justify-content-between mb-2">
                                                        <div>
                                                            <strong>Check In:</strong> 
                                                            <div v-if="isPermitExpired(item.todate)">
                                                                <b class="text-danger">Expired</b>
                                                            </div> 
                                                            <div v-else-if="isCheckoutGreater(item.max_check_in,item.max_check_out)">
                                                                <button @click="checkinitem(item.id,1)" class="btn btn-sm btn-primary">Check In</button>
                                                            </div> 
                                                            <div v-else>
                                                                {{ item.max_check_in }}
                                                            </div>
                                                        </div>
                                                        
                                                        <div>
                                                            <strong>Check Out:</strong>
                                                            <div v-if="!isCheckoutGreater(item.max_check_in,item.max_check_out) && !isPermitExpired(item.todate)">
                                                                <button @click="checkinitem(item.id,2)" class="btn btn-sm btn-primary">Check Out</button>
                                                            </div>
                                                            <div v-else>
                                                                Last: {{ item.max_check_out }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                    <div class="d-flex justify-content-between">
                                                        <button class="btn btn-sm btn-info" @click="getQrCode(item.token)">
                                                            <i class="icofont icofont-qr-code"></i>
                                                        </button>
                                                        <router-link :to="`/workpermitdetails?id=${item.id}`" class="btn btn-sm btn-success">
                                                            <i class="icofont icofont-file"></i>
                                                        </router-link>
                                                        <button @click="deleteitem(item.id)" v-if="user.empdept==sd" class="btn btn-sm btn-danger">
                                                            <i class="icofont icofont-trash"></i>
                                                        </button>
                                                         <button @click="resend_sms(item)" v-if="user.empdept==sd" class="btn btn-sm btn-danger">
                                                            <i class="icofont icofont-enevelope"></i>
                                                        </button>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                             
                            <div class="tab-pane fade" id="ongoing" role="tabpanel" aria-labelledby="ongoing-tab">
                                <div class="card-body px-0 pb-0">
                                    <div class="user-header pb-2">
                                        <h6 class="fw-bold">Active</h6>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6" v-for="(item, index) in active_workpermit" :key="item.id">
                                            <div class="card mb-3" v-if="!isPermitExpired(item.todate)">
                                                <div class="card-header bg-success text-white">
                                                    <h5>{{ item.name }}</h5>
                                                    <small>{{ item.companyname }}</small>
                                                </div>
                                                <div class="card-body">
                                                    <p><strong>Employee Name:</strong> {{ item.employee_name }}</p>
                                                    <p><strong>Register Date:</strong> {{ item.iddate }}</p>
                                                    <p><strong>Address:</strong> {{ item.address }}</p>
                                                    <p><strong>Contact:</strong> {{ item.contact }}</p>
                                                    <p><strong>Designation:</strong> {{ item.designation }}</p>
                                                    <p><strong>Valid From:</strong> {{ item.fromdate }} <strong>To:</strong> {{ item.todate }}</p>
                                                    
                                                    <div class="d-flex justify-content-between mb-2">
                                                        <div>
                                                            <strong>Check In:</strong> 
                                                            <div v-if="isCheckoutGreater(item.max_check_in,item.max_check_out)">
                                                                <button @click="checkinitem(item.id,1)" class="btn btn-sm btn-primary">Check In</button>
                                                            </div>
                                                            <div v-else>
                                                                {{ item.max_check_in }}
                                                            </div>
                                                        </div>
                                                        
                                                        <div>
                                                            <strong>Check Out:</strong>
                                                            <div v-if="!isCheckoutGreater(item.max_check_in,item.max_check_out) && !isPermitExpired(item.todate)">
                                                                <button @click="checkinitem(item.id,2)" class="btn btn-sm btn-primary">Check Out</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                    <div class="d-flex justify-content-between">
                                                        <button class="btn btn-sm btn-info" @click="getQrCode(item.token)">
                                                            <i class="icofont icofont-qr-code"></i>
                                                        </button>
                                                        <router-link :to="`/workpermitdetails?id=${item.id}`" class="btn btn-sm btn-success">
                                                            <i class="icofont icofont-file"></i>
                                                        </router-link>
                                                        <button @click="deleteitem(item.id)" class="btn btn-sm btn-danger">
                                                            <i class="icofont icofont-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            
                            <!-- Expired Work Permits Card View -->
                            <div class="tab-pane fade" id="requested" role="tabpanel" aria-labelledby="requested-tab">
                                <div class="card-body px-0 pb-0">
                                    <div class="user-header pb-2">
                                        <h6 class="fw-bold">Expired</h6>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6" v-for="(item, index) in expired_workpermit" :key="item.id">
                                            <div class="card mb-3" v-if="isPermitExpired(item.todate)">
                                                <div class="card-header bg-danger text-white">
                                                    <h5>{{ item.name }}</h5>
                                                    <small>{{ item.companyname }}</small>
                                                </div>
                                                <div class="card-body">
                                                    <p><strong>Register Date:</strong> {{ item.iddate }}</p>
                                                    <p><strong>Address:</strong> {{ item.address }}</p>
                                                    <p><strong>Contact:</strong> {{ item.contact }}</p>
                                                    <p><strong>Designation:</strong> {{ item.designation }}</p>
                                                    <p><strong>Valid From:</strong> {{ item.fromdate }} <strong>To:</strong> {{ item.todate }}</p>
                                                    
                                                    <div class="d-flex justify-content-between mb-2">
                                                        <div>
                                                            <strong>Check In:</strong> 
                                                            <b class="text-danger">Expired</b>
                                                        </div>
                                                        
                                                        <div>
                                                            <strong>Check Out:</strong>
                                                            Last: {{ item.max_check_out }}
                                                        </div>
                                                    </div>
                                                    
                                                    <div class="d-flex justify-content-between">
                                                        <button class="btn btn-sm btn-info" @click="getQrCode(item.token)">
                                                            <i class="icofont icofont-qr-code"></i>
                                                        </button>
                                                        <router-link :to="`/workpermitdetails?id=${item.id}`" class="btn btn-sm btn-success">
                                                            <i class="icofont icofont-file"></i>
                                                        </router-link>
                                                        <button @click="deleteitem(item.id)"  v-if="user.empdept==sd"  class="btn btn-sm btn-danger">
                                                            <i class="icofont icofont-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>








        
        <div v-else class="container-fluid">
            <div class="col-xxl-12">
                <div class="card">
                    <div class="card-header">
                       
                    </div>
                    <div class="card-body">
                        <ul class="nav nav-tabs border-tab border-0 mb-0 nav-danger" id="topline-tab" role="tablist">
                            <li class="nav-item"><a class="nav-link active nav-border pt-0 txt-danger nav-danger"
                                    id="all-gatepass-tab" data-bs-toggle="tab" href="#all-gatepass" role="tab"
                                    aria-controls="all-gatepass" aria-selected="true"><i
                                        class="icofont icofont-man-in-glasses"></i>All</a></li> 
                                        
                                        <li class="nav-item"><a class="nav-link nav-border txt-danger nav-danger" id="ongoing-tab"
                                            data-bs-toggle="tab" href="#ongoing" role="tab" aria-controls="ongoing"
                                            aria-selected="false"><i class="icofont icofont-listine-dots"></i>Active</a>
                                    </li>

                                    
                                    <li class="nav-item"><a class="nav-link nav-border txt-danger nav-danger" id="requested-tab"
                                            data-bs-toggle="tab" href="#requested" role="tab" aria-controls="requested"
                                            aria-selected="false"><i class="icofont icofont-listine-dots"></i>Expired</a>
                                    </li>

                                    <li>
                                        <button class="btn btn-primary" type="button" data-bs-toggle="modal"
                                        data-original-title="test" data-bs-target="#workpermitAdd"><i class="icofont icofont-plus"></i> Create Permit</button>
                                    </li>


                        </ul>
                        <div class="tab-content" id="topline-tabContent">
                            <div class="tab-pane fade show active" id="all-gatepass" role="tabpanel"
                                aria-labelledby="all-gatepass-tab">
                                <div class="card-body px-0 pb-0">
                                    <div class="user-header pb-2">
                                        <h6 class="fw-bold">All Work Permit:</h6>
                                        <button class="btn btn-primary text-white" @click="filterlist" >Filter</button>
                                    </div>

                                    <!-- <span class="badge bg-success ms-4 mt-2 mb-2"  @click="filterlist">Filter</span> -->
                                      



                                    <div class="user-content">
                                        <div class="table-responsive custom-scrollbar">
                                            <table class="table display datatable" id="All">
                                                <thead>
                                                    <tr>
                                                        <!-- <th></th> -->
                                                        <th>SR</th>
                                                        <th>Register Date</th>
                                                        <th>Employee Photo</th>
                                                        <th>Employee Name</th>
                                                        <th>Name</th>
                                                        <th>Company Name</th>
                                                        <th>Address</th>
                                                        <th>Contact</th>
                                                        <th>designation</th>
                                                        <th>Fromdate</th>
                                                        <th>Todate</th>
                                                        <th>Check In</th>
                                                        <th>Check Out</th>
                                                        <th>Action</th>
                                                        <!--<th>Delete</th>-->
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index)  in  workpermit">
                                                        <!-- <td><input type="checkbox" @click="() => { selectUsers(item.id) }"
                                                                :value="item.id" /></td> -->
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{ item.iddate }}</td>
                                                        <td> <a target="_blank" @click="_showingUserPic(item)"
                                                                itemprop="contentUrl" data-size="1600x950">
                                                                <img alt="" :src="getImageUrl(item)"
                                                                    v-if="item.image || item.image" class="avatar "
                                                                    itemprop="thumbnail" :alt="item.name">
                                                            </a> </td>
                                                        <td>{{ item.employee_name }}</td>
                                                        <td>{{ item.name }} </td>
                                                        <td>{{ item.companyname }} </td>
                                                        <td>{{ item.address }}</td>
                                                        <td>{{ item.contact }}</td>
                                                        <td>{{ item.designation }} </td>

                                                        <td>{{ item.fromdate }}</td>
                                                        <td>{{ item.todate }}</td>

                                                        
                                                        <td>
                                                            
                                                             <div v-if="isPermitExpired(item.todate)">
                                                               <b class="text-danger">Expired</b>
                                                            </div> 
                                                            <div v-else-if="isCheckoutGreater(item.max_check_in,item.max_check_out)">
                                                                <button @click="checkinitem(item.id,1)" class="btn-primary">Check In</button>
                                                            </div> 
                                                            <div v-else>
                                                                {{ item.max_check_in }}
                                                            </div>
                                                         

                                                        </td>
                                                

                                                        <td>
                                                            <div v-if="!isCheckoutGreater(item.max_check_in,item.max_check_out) && !isPermitExpired(item.todate)">
                                                                <button @click="checkinitem(item.id,2)" class="btn-primary">Check Out</button>
                                                            </div>
                                                            <div v-else>
                                                                Last : {{ item.max_check_out }}
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <ul class="action">
                                                                <li class="link" 
                                                                    @click="getQrCode(item.token)"><i
                                                                        class="icofont icofont-qr-code"></i></li>

                                                                          <li title="Print Pass"
                                                                    @click="print_pass(item.id)"><i
                                                                        class="icon-printer"></i></li>
                                                                        
                                                            <li class="link"> <router-link :to="`/workpermitdetails?id=${item.id}`">View</router-link></li>
                                                            
                                                              <li class="link" 
                                                                    @click="resend_sms(item)"><i
                                                                        class="icofont icofont-envelope"></i></li>
                                                                        
                                                                         
                                                            </ul>
                                                          </td>                                                          
                                                          <!--<td>-->
                                                            <!--<button @click="deleteitem(item.id)" class="btn-primary">Delete</button>-->
                                                          <!--</td>-->
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          
                     
             <!-- start Active Workpermit------------------------------------------------------------------------------------------------>

             <div class="tab-pane fade" id="ongoing" role="tabpanel" aria-labelledby="ongoing-tab">
                <div class="card-body px-0 pb-0">
                    <div class="user-header pb-2">
                        <h6 class="fw-bold">ACTIVE</h6>
                    </div>
                 
                    <div class="user-content">
                        <div class="table-responsive custom-scrollbar">
                            <table class="table display datatable" id="Active">
                                <thead>
                                    <tr>
                                        <!-- <th></th> -->
                                        <th>SR</th>
                                        <th>Register Date</th>
                                        <th>Name</th>
                                        <th>Company Name</th>
                                        <th>Address</th>
                                        <th>Contact</th>
                                        <th>designation</th>
                                        <th>Fromdate</th>
                                        <th>Todate</th>
                                        <th>Check In</th>
                                        <th>Check Out</th>
                                        <th>Action</th>
                                        <!--<th>Delete</th>-->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index)  in  active_workpermit" >
                                        <!-- <td><input type="checkbox" @click="() => { selectUsers(item.id) }"
                                                :value="item.id" /></td> -->
                                        <td>{{ index+1 }}</td>
                                        <td>{{ item.iddate }}</td>
                                    
                                        <td>{{ item.name }} </td>
                                        <td>{{ item.companyname }} </td>
                                        <td>{{ item.address }}</td>
                                        <td>{{ item.contact }}</td>
                                        <td>{{ item.designation }} </td>

                                        <td>{{ item.fromdate }}</td>
                                        <td>{{ item.todate }}</td>

                                        
                                        <td> 
                                              <div v-if="isPermitExpired(item.todate)">
                                                               <b class="text-danger">Expired</b>
                                                            </div> 
                                                            <div v-else-if="isCheckoutGreater(item.max_check_in,item.max_check_out)">
                                                                <button @click="checkinitem(item.id,1)" class="btn-primary">Check In</button>
                                                            </div>
    
                                                        <div v-else>
                                                            {{ item.max_check_in }}
                                                        </div>


                                        </td>
                                

                                        <td>
                                            <div v-if="!isCheckoutGreater(item.max_check_in,item.max_check_out) && !isPermitExpired(item.todate)">
                                                <button @click="checkinitem(item.id,2)" class="btn-primary">Check Out</button>
                                            </div>
                                        </td>

                                        <td>
                                            <ul class="action">
                                                <li class="link" 
                                                    @click="getQrCode(item.token)"><i
                                                        class="icofont icofont-qr-code"></i></li>

                                                        
                                            <li class="link"> <router-link :to="`/workpermitdetails?id=${item.id}`">View</router-link></li>
                                            </ul>
                                          </td>                                                          
                                          <!--<td>-->
                                            <!--<button @click="deleteitem(item.id)" class="btn-primary">Delete</button>-->
                                          <!--</td>-->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
              <!-- end active workpermit------------------------------------------------------------------------------------------------->

           <!-- start expiry work-permit------------------------------------------------------------------------------------------------->

           <div class="tab-pane fade" id="requested" role="tabpanel" aria-labelledby="requested-tab">
            <div class="card-body px-0 pb-0">
                <div class="user-header pb-2">
                    <h6 class="fw-bold">Expired</h6>
                </div>
                <div class="user-content">
                    <div class="table-responsive custom-scrollbar">
                        <table class="table display datatable" id="Expired">
                            <thead>
                                <tr>
                                    <!-- <th></th> -->
                                    <th>SR</th>
                                    <th>Register Date</th>
                                    <th>Name</th>
                                    <th>Company Name</th>
                                    <th>Address</th>
                                    <th>Contact</th>
                                    <th>designation</th>
                                    <th>Fromdate</th>
                                    <th>Todate</th>
                                    <th>Check In</th>
                                    <th>Check Out</th>
                                    <th>Action</th>
                                    <!--<th>Delete</th>-->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index)  in  expired_workpermit" :key="item.workpermitid" if="!compareTodayDate(item.max_check_in,item.max_check_out)" >
                                    <!-- <td><input type="checkbox" @click="() => { selectUsers(item.id) }"
                                            :value="item.id" /></td> -->
                                    <td>{{ index+1 }}</td>
                                    <td>{{ item.iddate }}</td>
                                
                                    <td>{{ item.name }} </td>
                                    <td>{{ item.companyname }} </td>
                                    <td>{{ item.address }}</td>
                                    <td>{{ item.contact }}</td>
                                    <td>{{ item.designation }} </td>

                                    <td>{{ item.fromdate }}</td>
                                    <td>{{ item.todate }}</td>

                                    
                                    <td>

                                          <div v-if="isPermitExpired(item.todate)">
                                                               <b class="text-danger">Expired</b>
                                                            </div> 
                                                            
                                                            <div v-else-if="isCheckoutGreater(item.max_check_in,item.max_check_out)">
                                                                <button @click="checkinitem(item.id,status=1)" class="btn-primary">Check In</button>
                                                            </div> 
                                                            <div v-else>
                                                                {{ item.max_check_in }}
                                                            </div>


                                    </td>
                            

                                    <td>
                                        <div v-if="!isCheckoutGreater(item.max_check_in,item.max_check_out) && !isPermitExpired(item.todate)">
                                            <button @click="checkinitem(item.id,status=2)" class="btn-primary">Check Out</button>
                                        </div>
                                    </td>

                                    <td>
                                        <ul class="action">
                                            <li class="link" 
                                                @click="getQrCode(item.token)"><i
                                                    class="icofont icofont-qr-code"></i></li>

                                                    
                                        <li class="link"> <router-link :to="`/workpermitdetails?id=${item.id}`">View</router-link></li>
                                        </ul>
                                      </td>                                                          
                                      <!--<td>-->
                                        <!--<button @click="deleteitem(item.id)" class="btn-primary">Delete</button>-->
                                      <!--</td>-->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

   </div>











           <!--end expiry work-permit---------------------------------------------------------------------------------------------------->








                    </div>
                </div>
            </div>
        </div>
    </div>





<!-- filterModel -->




<div class="modal" v-if="showfilterModel" style="display: block; background-color: rgba(0,0,0,0.5);" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Filter</h5>
          <button type="button" class="close" @click="showfilterModel = false" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">

            <div class="col-12 row" >


                <div class="col-6">
                <label class="form-label">From Date</label>
                <input class="form-control" type="date" 
                    v-model="filter_wp.fromdate_" placeholder="Type Here..." required>
                </div>

                <div class="col-6">
                    <label class="form-label">To Date</label>
                    <input class="form-control" type="date" 
                        v-model="filter_wp.todate" placeholder="Type Here..." required>
                    </div>
                </div>

                <div class="col-12 row" >

                    <div class="col-6 mt-2">
                        <!-- <label class="form-label">Visitor Name</label>
                        <select class="form-control" v-model="filter_wp.visitorid" required>
                            <option value="0">All</option>
                            <option v-for="item in workpermit" :key="item.id" :value="item.name">
                                {{ item.name }} / {{ item.contact }}
                            </option>
                        </select> -->


                        <label class="form-label">Visitor Name</label>   
                        <Autocomplete 
                              :items="visitorname" 
                              labelField="companyandname" 
                              valueField="id"
                              placeholder="Search Visitor"
                              @select="handleSelectVisitor" />
    
                              </div>








                        <div class="col-6 mt-2">
                            <!-- <label class="form-label">Company Name</label>
                            <select class="form-control" v-model="filter_wp.companyid" required>
                                <option value="0">All</option>
                                <option v-for="item in workpermit" :key="item.id" :value="item.companyname">
                                    {{ item.companyname }} 
                                </option>
                            </select>
                            </div> -->



                            <label class="form-label">Company Name</label>   
                            <Autocomplete 
                                  :items="companyname" 
                                  labelField="companyname" 
                                  valueField="companyname"
                                  placeholder="Search Company"
                                  @select="handleSelectCompany" />
        
                                  </div>
    



                            </div>




                

        </div>
        <div class="modal-footer">
        
          <button type="button" class="btn btn-primary" @click="getfilterlist">Filter</button>
        </div>
      </div>
    </div>
  </div>
















<!-- filterModel -->




























    <div class="modal fade" id="qrcodeView" tabindex="-1" role="dialog" aria-labelledby="qrcodeView" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">QR Code</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper ">
                        <div class="col-sm-12">
                            <canvas ref="qrcodeCanvas"></canvas>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">

                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="modal fade" id="showingUserPic" tabindex="-1" role="dialog" aria-labelledby=" "
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{!showingUserPic.isadhar?'User Image':'Adhar Card'}}</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper ">
                        <div class="col-sm-12">
                            
                              <img v-if="showingUserPic.image" alt="" :src="getImageUrl(showingUserPic)"
                                                                     class="img img-thumbnail" :alt="showingUserPic.name"/>
                                                                    
                           
                        </div>
                    </div>
                </div>
                <!--<div class="modal-footer">-->
                <!--    <div class="col-12">-->
                <!--        <button class="btn btn-primary" @click=""> </button>-->
                <!--    </div>-->
                <!--</div>-->
            </div>
        </div>
    </div>
    
    <ModalsPart v-if="!['login'].includes($route.name)" @getworkpermitData="updateData" />
</template>
<style scoped>
.avatar {
    width: 50px;
    height: 50px;
    border-radius: 30px;
}

.badge_sm {
    padding: 2px 5px;
    border-radius: 10px;
    font-size: smaller;
    color: white;
}
.card-body p,
.card-body h5 {
  margin-bottom: 0.25rem; /* Reduced spacing */
}
.action{
    gap: 10px;
}
</style>
<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
import GatePass from '@/components/GatepassPrint.vue';
import Swal from 'sweetalert2';
// import axios from 'axios';
import axios from "@/plugins/axios";
import QRCode from 'qrcode';

export default {
    name: 'CreateGatepass',
    components: {
        PageTitle, ModalsPart, GatePass
    }, mounted() {
        this.getBasics();
        

    }, data() {
        const today = new Date().toISOString().split('T')[0]; // Formats to 'YYYY-MM-DD'
        return {
            reschedule: [],
            user: [],
            workpermit:[],
            active_workpermit:[],
            expired_workpermit:[],
            companyname:[],
            visitorname:[],
            sd:0,
            date:{
                fromdate: today,
                todate: today
            },
            dataTable:null,
            today_data:today,
            filter_wp:{
              
              fromdate_:this.todayDate(),
              todate:this.todayDate(),
              visitorid:'',
              companyid:'',


          },
          showfilterModel:false,
          today_date:this.todayDate(),
           showingUserPic:{
                photo:'',
                name:'',
                isadhar:false
            },
        }
    }, 
    methods: {

        updateData(value) {
                var self=this;
                self.destroyTable();
                self.workpermit = value;
                self.$nextTick(() => { self.refreshTable(); });
        },

        getBasics() {
            var self = this;
            axios.post('getworkpermit').then(function (response) {
                self.workpermit = response.data.workpermit;
                self.active_workpermit = response.data.active_workpermit;
                self.expired_workpermit = response.data.expired_workpermit;
                self.companyname = response.data.companyname;
                self.visitorname = response.data.visitorname;
                window.scrollTo(0, 0);
            }).then(() => {
                self.refreshTable();
            });


        },
          isPermitExpired(todate) {
            //   alert(todate+''+this.todayDate);
                return  new Date(todate) <  new Date(this.today_date);
                },
                
        isCheckoutGreater(checkInDate,checkOutDate) {
                    
                    if(checkInDate && !checkOutDate)
                        return false
                    else if(checkOutDate){
                        const inDate = new Date(checkInDate.replace(' ', 'T'));
                        const outDate = new Date(checkOutDate.replace(' ', 'T')); 
                        return outDate > inDate;
                    }else
                     return true;
                    
                },
                
        compareTodayDate(checkInDate,checkOutDate) {
                if(new Date(today_data)>= new Date(checkInDate) && new Date(today_data)<= new Date(checkOutDate))
                    return true;
                else
                    return false;
                },


        deleteitem(id) {
        var self = this;
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you really want to delete this?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
        if (result.isConfirmed) {
            axios.post('deleteworkpermit', { id: id }).then(function (response) {
                self.workpermit = response.data.workpermit;
              
                window.scrollTo(0, 0);
                Swal.fire(
                    'Deleted!',
                    'The item has been deleted.',
                    'success'
                );
            });
        }
    });
},
async getQrCode(token) {
    // alert(token);
            try {
                if (token.length > 0) {
                    const canvas = this.$refs.qrcodeCanvas;
                    var url = this.$api_host + 'wp?q=' + token; 
                    // this.$router.push(`/wp?q=${token}`);
 
                     
                    await QRCode.toCanvas(canvas, url, { width: 200 });
                    $("#qrcodeView").modal("toggle");
                    // window.open(window.location.origin + "/wp?q=" + token, '_blank');
                }

            } catch (error) {
                console.error(error);
            }
        },
    

        checkinitem(id,status) {
    var self = this;

    axios.post('checkinworkpermit', { id: id, status: status })
        .then(function (response) {
            self.destroyTable();
              self.workpermit = response.data.workpermit;
                self.active_workpermit = response.data.active_workpermit;
                self.expired_workpermit = response.data.expired_workpermit;
                self.companyname = response.data.companyname;
                self.visitorname = response.data.visitorname;
             
                self.$swal(response.data.message+"");
          
            window.scrollTo(0, 0);

        }).then(() => {
                self.refreshTable();
            });

   
},
 
 destroyTable(){
    if ($.fn.dataTable.isDataTable('#All')) {
                                    $('#All').DataTable().destroy();
                                }
                if ($.fn.dataTable.isDataTable('#Active')) {
                                    $('#Active').DataTable().destroy();
                                }
                if ($.fn.dataTable.isDataTable('#Expired')) {
                                    $('#Expired').DataTable().destroy();
                }
},
 refreshTable(){
    var self=this;
     this.$nextTick(() => {
    $("#All").DataTable({
                        dom: 'Bfrtip',
                        buttons: ['excel', 'pdf',{
                                                text: 'Filter',
                                                action: function (e, dt, node, config) {
                                                  self.filterlist();
                                                }
                                              }],
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false,
                       "aaSorting": []
                    });
                    
                    $("#Active").DataTable({
                        dom: 'Bfrtip',
                        buttons: ['excel', 'pdf'],
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false,
                        "aaSorting": []
                    });
                    $("#Expired").DataTable({
                        dom: 'Bfrtip',
                        buttons: ['excel', 'pdf'],
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false,
                       "aaSorting": []
                    });
     });
}
,
filter() {
            var self = this;
            axios.post('filtergetworkpermit',self.date).then(function (response) {
               
                self.destroyTable();
                self.workpermit = response.data.workpermit;
                window.scrollTo(0, 0);
            }).then(() => {
                 self.refreshTable();
            });


        },

        
            filterlist(){


        this.showfilterModel=true;


        },

        todayDate() {
                var today = new Date();
                var month = today.getMonth() + 1;

                return today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;

            },

            getfilterlist() {
            var self = this;
            axios.post('getfilterworkpermit',self.filter_wp).then(function (response) {
                self.destroyTable();
                
                self.workpermit = response.data.workpermit;
                
                self.status = response.data.status;
                window.scrollTo(0, 0);
        
                 if(self.status == 1){
                    self.$swal("Filtered");
                    self.showfilterModel=false;
                 } 

          


            }).then(() => {
                self.refreshTable();
            });


        },


        isMobileView() {
      if (window.innerWidth <= 768) {
        //   alert("Yes");
        return true;
        } else {
            // alert("No");
          return false;
        }
      },



      handleSelectVisitor(selectedvisitor) {
             this.filter_wp.visitorid= selectedvisitor.id;
    },

    handleSelectCompany(selectedcompany) {
             this.filter_wp.companyid= selectedcompany.companyname;
    },


   _showingUserPic(gatepass_row,isAdhar=false) {
                    this.showingUserPic.name = gatepass_row.name;
                    this.showingUserPic.image = gatepass_row.image ;
                    
                    $("#showingUserPic").modal("toggle");
        },
          getImageUrl(row) {
            //return `${this.$hostname}/writable/uploads/visitors/${image}`;
            let wp='';
             
                    wp='wp/';
            
          if(row.image && !row.image.includes('.bin'))
                return `${this.$hostname}writable/uploads/visitors/${wp+row.image.replace(/^wp\//, '')}`;
            else
                return `${this.$hostname}writable/visitors/user.png`;
        },
        print_pass(gatepassid) {
            window.open(window.location.origin + "/printwp?q=" + gatepassid, '_blank');
        },
        
        
        //14.09.2025
           resend_sms (item) {
                var self = this;
            
                axios.post('resend_sms', { toke: item.token })
                    .then(function (response) {
                        
                            self.$swal(response.data.message+"");
                       
            
                    }).then(() => {
                            
                        });
            
               
            },
     
          
    }
}
</script>
